import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import './i18n';
import App from './App';
import reportWebVitals from './reportWebVitals';
import {Provider} from 'react-redux'
import store from 'shared-redux/reducers/store'

// Prerendered pages arrive with real markup already in #root (see
// scripts/prerender.js). hydrateRoot adopts it; createRoot would discard it
// and repaint, which throws away the very HTML search engines are indexing
// and causes a visible flash on first load.
const container = document.getElementById('root');
const tree = (
  <React.StrictMode>
    <Provider store={store}>
    <App />
    </Provider>
  </React.StrictMode>
);

if (container.hasChildNodes()) {
  ReactDOM.hydrateRoot(container, tree);
} else {
  ReactDOM.createRoot(container).render(tree);
}

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
